import { render, staticRenderFns } from "./TradingAccount.vue?vue&type=template&id=0a0cb241&"
import script from "./TradingAccount.vue?vue&type=script&lang=js&"
export * from "./TradingAccount.vue?vue&type=script&lang=js&"
import style0 from "./TradingAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports